import { createContext } from "react";

export const UPMStateContext = createContext();
